import axios from 'axios';

const api = process.env.REACT_APP_BANKVERIFY_URL;

export const BankAccNumberVerify = async (
  ifsc_code,
  account_number,
  setAlertMessage,
  setErrOpen,
  setVerified,
  setAlertType,
  setOpenLoader,
  setVerifyResponse,
  setNameBank,
  name
) => {
  let dummy = name;

  try {
    setOpenLoader(true);
    await axios
      .post(
        `${api}/idfy-bank-verification/bank/verify_bank`,
        {
          ifsc_code,
          account_number,
          task_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta',
          group_id: sessionStorage.getItem('user_code') ? sessionStorage.getItem('user_code') : 'finvesta'
        },
        {
          headers: {
              Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setOpenLoader(false);
        const request_id = res.data.details.request_id;
        if (request_id) {
          sessionStorage.setItem('request_id', request_id);

          VerifyBank_Request_id(
            ifsc_code,
            account_number,
            setAlertMessage,
            setErrOpen,
            setVerified,
            setAlertType,
            setOpenLoader,
            setVerifyResponse,
            setNameBank,
            0,
            dummy
          );
          // handleClick();
          // sessionStorage.setItem("")
        }
      });
  } catch (error) {
    setOpenLoader(false);
    setAlertMessage(error.message);
    setAlertType('error');
    setErrOpen(true);
  }
};

export const VerifyBank_Request_id = async (
  ifsc_code,
  account_number,
  setAlertMessage,
  setErrOpen,
  setVerified,
  setAlertType,
  setOpenLoader,
  setVerifyResponse,
  setNameBank,
  instance,
  name
) => {
  const request_id = sessionStorage.getItem('request_id');
  let retry = instance;
  try {
    setOpenLoader(true);
    await axios
      .post(
        `${api}/idfy-bank-verification/bank/task_details`,
        { request_id },
        {
          headers: {
                    Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        setOpenLoader(false);
        if (res.data.details.result.status === 'id_found') {
          // const bankname = res.data.details.result.name_at_bank;
          const bankname = res.data.details.result.name_at_bank
            .replace(/^\s*(mr\.|mrs\.|master\.|miss\.|ms\.|dr\.|mr|mrs|master|miss|ms|dr)\s+/i, '')
            .toLowerCase()
            .trim();
            // .replace(/\s+/g, '')
          const agname = name ? name.toLowerCase().trim() : 'name';
          const bankWords = bankname.split(' ');
          const aadhaarWords = agname.split(' ');

          const bankFirstName = bankWords[0];
          const bankLastName = bankWords[bankWords.length - 1];

          const aadhaarFirstName = aadhaarWords[0];
          const aadhaarLastName = aadhaarWords[aadhaarWords.length - 1];

          const ValidateName = bankFirstName === aadhaarFirstName && bankLastName === aadhaarLastName;
          if (!ValidateName) {
            setAlertMessage('The name does not match the name on your bank account.');
            setAlertType('error');
            setErrOpen(true);
          } else if (ValidateName) {
            setVerifyResponse(res.data);
            setVerified(true);
            setAlertMessage('Account Verified Successfully');
            setNameBank(res.data.details.result.name_at_bank);
            sessionStorage.setItem('BankAccVerified', true);
            sessionStorage.setItem('od_ifsc_code', ifsc_code);
            sessionStorage.setItem('od_account_number', account_number);
            sessionStorage.setItem('od_account_name', res.data.details.result.name_at_bank);
            setAlertType('success');
            setErrOpen(true);
          }
        } else if (res.data.details.result.status === 'id_not_found') {
          setAlertMessage('Account number does not match the selected bank. Please re-enter the correct account number');
          setAlertType('error');
          setErrOpen(true);
        } else if (res.data.details.result.status === 'ind_vpa') {
          setAlertMessage('Upi id is invalid');
          setAlertType('error');
          setErrOpen(true);
        }
      }).catch((error)=>{
        if (retry < 4) {
          setTimeout(() => {
            VerifyBank_Request_id(
              ifsc_code,
              account_number,
              setAlertMessage,
              setErrOpen,
              setVerified,
              setAlertType,
              setOpenLoader,
              setVerifyResponse,
              setNameBank,
              retry + 1,
              name
            );
          }, 2000);
        }else{
          setOpenLoader(false);
          setAlertMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error : 'Unable to verify bank account number');
          setAlertType('error');
          setErrOpen(true);
        }
      })
  } catch (error) {
    if (retry < 4) {
      setTimeout(() => {
        VerifyBank_Request_id(
          ifsc_code,
          account_number,
          setAlertMessage,
          setErrOpen,
          setVerified,
          setAlertType,
          setOpenLoader,
          setVerifyResponse,
          setNameBank,
          retry + 1,
          name
        );
      }, 2000);
    } else {
      setOpenLoader(false);
      console.log('error', error);
      setAlertMessage(error.response.data.message ? error.response.data.message : error.response.data.error? error.response.data.error : 'Unable to verify bank account number');
      setAlertType('error');
      setErrOpen(true);
    }
  }
};
